import React from 'react';
import PropTypes from 'prop-types'

const Pokeball = (props) => {
    const { mode } = props
    return(
        <div>
            <img src={`/img/icons/icon-pokeball-${mode}.png`} alt="Pokeball"/>
        </div>
    )
}

Pokeball.defaultProps = {
    mode: 'light',
}

Pokeball.propTypes = {
    mode: PropTypes.oneOf(['light', 'dark']),
}

export default Pokeball